import { render, staticRenderFns } from "./toSubModal.vue?vue&type=template&id=6e80b3eb&scoped=true"
import script from "./toSubModal.vue?vue&type=script&lang=js"
export * from "./toSubModal.vue?vue&type=script&lang=js"
import style0 from "./toSubModal.vue?vue&type=style&index=0&id=6e80b3eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e80b3eb",
  null
  
)

export default component.exports